import { Dialog } from "primereact/dialog";
import React from "react";

import Spinner from "presentation/components/Shared/Spinner";
import DocumentViewer from "presentation/components/Shared/ViewDocument";

interface DocumentViewerDialogProps {
  visible: boolean;
  title: string;
  documentUrl: string | null;
  loading: boolean;
  onHide: () => void;
}

const DocumentViewerDialog: React.FC<
  DocumentViewerDialogProps
> = ({ visible, title, documentUrl, loading, onHide }) => {
  return (
    <Dialog
      header={title}
      visible={visible}
      style={{ width: "75vw", height: "90vh" }}
      maximizable
      onHide={onHide}
    >
      {loading && <Spinner />}
      {!loading && documentUrl && (
        <DocumentViewer url={documentUrl} height="50vh" />
      )}
    </Dialog>
  );
};

export default DocumentViewerDialog;
